import React from "react";
import { Button, Card, Col, Form, Pagination, Row } from "react-bootstrap";
import { AddCountry, DeleteCountryModule } from "../modals/allModal";
import { CircularProgress, Grid } from "@mui/material";
import { useEffect } from "react";
import CountryService from "../../services/country.service";
import { useState } from "react";
import * as yup from "yup";
import useDialogState from "../../hooks/useDialog";
import { useFormik } from "formik";

const schema = yup.object().shape({
  countryName: yup.string().required("Please Select Country Name"),
  files: yup.mixed().required("Please Upload Country Image"),
  filesRatio: yup.mixed().required("Please Upload Country Image"),
});

const CountryList = () => {
  const {
    open: modalShow,
    handleClickOpen: handleDialogOpen,
    handleClose: handleDialogClose,
  } = useDialogState();
  const [searchText, setSearchText] = useState("");
  const [deleteName, setDeleteName] = useState("");
  const [page, setPage] = useState(1);
  const [deleteRace, setDeleteRace] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [loader, setLoader] = useState(false);
  const [totalRecords, setTotalRecords] = useState("");
  const [selectedImages, setSelectedImages] = useState("");
  const handleCloseCountry = () => setDeleteRace(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const pageSize = Math.ceil(totalRecords / 12);
  const getAllCountry = async (page) => {
    setLoading(true);
    const response = await CountryService.GetCountryList(searchText, page);
    setData(response.data.data);
    setLoading(false);
    setTotalRecords(response.data.totalCountry);
  };

  const handleSearchText = (e) => {
    const text = e.target.value.trim().toLowerCase();
    setSearchText(text);
  };

  const initialValue = {
    countryName: "",
    files: "",
    filesRatio: "",
  };


  const submit = async (values, action) => {
    const { countryName, files, filesRatio } = values;
    if (!values.countryId) {
      try {
        const fileData = new FormData();
        fileData.append("files", files);
        setLoader(true);
        const response =  await CountryService.addCountry(countryName, fileData);
        if(response.data.status){
          const fileData2 = new FormData();
          fileData2.append("files", filesRatio);
         await CountryService.addCountryImageRatio(response.data.data._id, fileData2);
        }
        setLoader(false);
        handleDialogClose();
        setSelectedImages(null);
        getAllCountry();
        action.resetForm();
      } catch (error) {
        console.error("create race error", error);
        setLoader(false);
      }
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const handleOpen = async () => {
    handleDialogOpen();
    formik.setFieldValue("countryName", "");
    formik.setFieldValue("files", "");
  };

  useEffect(() => {
    getAllCountry();
  }, [searchText]);

  const showFileToUpload = (e) => {
    const selectedFile = e.currentTarget.files[0];
    formik.setFieldValue("files", selectedFile);
    const imageUrl = URL.createObjectURL(selectedFile);
    setSelectedImages(imageUrl);
  };
  const showFileToUpload2 = (e) => {
    const selectedFile = e.currentTarget.files[0];
    formik.setFieldValue("filesRatio", selectedFile);
  };

  const handelDelete = (id, name) => {
    setDeleteRace(true);
    setDeleteId(id);
    setDeleteName(name);
  };

  const nextPage = (page) => {
    setPage(page);
    getAllCountry(page);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const previousPage = () => {
    setPage(page - 1);
    getAllCountry();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col sm={12} md={6} lg={6} xl={3}>
          <Card className="custom-card">
            <Card.Body>
              <div className="card-order ">
                <label className="main-content-label font-weight-bold mb-3 pt-1">
                  Total Country
                </label>
                <h2 className="text-end card-item-icon card-icon">
                  <i className="mdi mdi-flag icon-size float-start text-primary"></i>
                  <span className="font-weight-bold">{totalRecords}</span>
                </h2>
              </div>
            </Card.Body>
          </Card>
        </Col>
        <Col
          sm={12}
          md={6}
          lg={6}
          xl={4}
          className="ms-auto mt-auto d-flex"
          style={{ justifyContent: "end" }}
        >
          <div>
            <Form.Control
              type="search"
              placeholder="Search"
              className="me-2"
              aria-label="Search"
              onChange={(e) => handleSearchText(e)}
            />
          </div>
          <div className="custom-card text-end  pointer me-5 ms-3">
            <Button className="text-white" onClick={() => handleOpen("")}>
              <i className="fas fa-plus"></i> &nbsp; Add Country
            </Button>
            <AddCountry
              show={modalShow}
              loader={loader}
              onHide={handleDialogClose}
              selectedImages={selectedImages}
              formik={formik}
              showFileToUpload={showFileToUpload}
              showFileToUpload2={showFileToUpload2}
              setSelectedImages={setSelectedImages}
            />
          </div>
        </Col>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "50px",
          }}
        >
          <CircularProgress size={30} />
        </div>
      ) : (
        <Row className="row m-auto">
          {data &&
            data.map((card) => (
              <Col sm={12} md={6} lg={4} xl={4} xxl={3}>
                <Grid
                  sx={{
                    display: "flex",
                    justifyContent: {
                      sm: "center",
                      xs: "center",
                      md: "start",
                      marginBottom: "15px",
                    },
                  }}
                >
                  <Card
                    className="custom-card pointer"
                    style={{ height: "250px", width: "350px" }}
                  >
                    <img
                      src={card.countryImage}
                      className="rounded-lg img-fit-cover pos-relative"
                      alt="img"
                    />
                    {card.raceStatus !== "active" && (
                      <button
                        style={{
                          position: "absolute",
                          bottom: 0,
                          right: 10,
                        }}
                        className="text-white ms-3 mb-2 btn btn-primary"
                        onClick={() => handelDelete(card._id, card.countryName)}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    )}
                    <Card.Body className="pos-absolute card-body2">
                      <div
                        className="card-order bg-000"
                        style={{ border: "1px solid #000" }}
                      >
                        <label
                          className="main-content-label font-weight-bold mb-0 pointer"
                          style={{ border: "1px solid #000 !importan" }}
                        >
                          {card.countryName}
                        </label>
                      </div>
                    </Card.Body>
                  </Card>
                </Grid>
              </Col>
            ))}
          {deleteRace && (
            <DeleteCountryModule
              show={deleteRace}
              onHide={handleCloseCountry}
              id={deleteId}
              name={deleteName}
              GetCountryData={getAllCountry}
            />
          )}
        </Row>
      )}
      <Pagination
        className="pagination-circle mb-0 ms-lg-3"
        style={{ justifyContent: "center" }}
      >
        <Pagination.Item
          onClick={() => previousPage(page - 1)}
          disabled={page === 1}
        >
          <i className="fas fa-angle-double-left"></i>
        </Pagination.Item>
        {Array.from({ length: Math.ceil(totalRecords / 12) }).map(
          (_, index) => {
            const pageNumber = index + 1;
            return (
              <Pagination.Item
                onClick={() => nextPage(pageNumber)}
                key={pageNumber}
                active={pageNumber === page}
              >
                {pageNumber}
              </Pagination.Item>
            );
          }
        )}
        <Pagination.Item
          onClick={() => nextPage(page + 1)}
          disabled={pageSize === page}
        >
          <i className="fas fa-angle-double-right"></i>
        </Pagination.Item>
      </Pagination>
    </>
  );
};

export default CountryList;
